export default __webpack_public_path__ + "static/media/machine-2.4981d945.svg";